export default __webpack_public_path__ + "23d76b8.png";